<template>
  <div class="home">
    <div class="scroll-container">
      <home-header
        :tenantName="tenantName"
        :tenantImg="tenantImg"
        @chooseSchool="schoolPopup = !schoolPopup"
      ></home-header>
      <div class="date" @click="arrowTime = !arrowTime">
        <div class="date-name">{{ recipeName }}</div>
        <van-divider class="my-divider" />
      </div>
      <div class="container" v-if="tabs.length > 0">
        <van-tabs
          class="channel-tabs"
          v-model="active"
          background="none"
          ellipsis
          @change="onChange"
          swipeable
          animated
        >
          <van-tab
            v-for="(item, index) in tabs"
            :title="item.name"
            :name="item.id"
            :key="item.id"
          >
            <recipe-detail
              class="swiper-slide"
              :tenantId="tenantId"
              :id="active"
              @up-week="updateWeek"
              :current-week="currentWeek"
              :active="index"
              @showHelp="showHelp = true"
            ></recipe-detail>
          </van-tab>
        </van-tabs>
      </div>
      <no-recipe v-else></no-recipe>
    </div>
    <home-footer v-if="tabs.length > 0" :id="currentRecipeId"></home-footer>
    <!-- 选择时间弹窗 -->
    <van-calendar
      v-model="arrowTime"
      :min-date="minDate"
      color="#846ffe"
      :first-day-of-week="1"
      safe-area-inset-bottom
      :show-confirm="false"
      @confirm="onConfirm"
    />
    <!-- 选择学校弹窗 -->
    <van-popup
      v-model="schoolPopup"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="school-popup">
        <div class="school-title">选择学校</div>
        <div class="school-list">
          <div
            class="school-item"
            v-for="item in schoolList"
            :key="item.sysTenantId"
            @click="handleChangeSchool(item)"
          >
            <img v-if="item.logoUrl" :src="item.logoUrl" alt="" />
            <img v-else src="../../assets/account.svg" alt="" />
            <div class="name">{{ item.tenantName }}</div>
          </div>
          <div class="school-item" @click="handleBindSchool">
            <img src="@/assets/home/add.svg" alt="" />
            <div class="name">绑定学校</div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 评分规则弹窗 -->
    <van-overlay :show="showHelp" @click="showHelp = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="block-title">
            <img src="@/assets/home/help_icon.svg" alt="" />
            <span>营养评级说明</span>
          </div>
          <div class="block-item" v-for="item in helpInfo" :key="item.id">
            <div class="block-item-level">{{ item.level }}</div>
            <div class="block-item-des">{{ item.des }}</div>
          </div>
          <div class="block-button">
            <van-button color="#846FFE" round block @click="showHelp = false"
              >知道了</van-button
            >
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import HomeHeader from './component/home-header.vue'
import NoRecipe from './component/no-recipe.vue'
import RecipeDetail from './component/recipe-detail.vue'
import moment from 'moment'
import { mapState } from 'vuex'
// import { Notify } from 'vant'
import { bindSchoolList, recipeListByTime } from '../../api/searchFoods'
import HomeFooter from './component/home-footer.vue'
export default {
  components: { HomeHeader, NoRecipe, RecipeDetail, HomeFooter },
  name: 'Home',
  data() {
    return {
      loading: true,
      tenantImg: '', // 学校头像
      tenantName: '', // 学校名字
      tenantId: 0, // 学校id
      arrowTime: false, // 选择时间弹窗
      schoolPopup: false, // 选择学校弹窗
      schoolList: [], // 绑定学校列表
      MondayTime: moment(
        new Date(
          new Date().getTime() -
            ((new Date().getDay() || 7) - 1) * 24 * 60 * 60 * 1000
        )
      ).format('YYYY.MM.DD'),
      SundayTime: moment(
        new Date(
          new Date().getTime() +
            (7 - (new Date().getDay() || 7)) * 24 * 60 * 60 * 1000
        )
      ).format('YYYY.MM.DD'),
      minDate: new Date(2020, 0, 1),
      active: 1,
      tabs: [], // 食谱简称标签
      recipeListArr: [], // 当前时间段食谱列表
      currentRecipe: {}, // 当前食谱
      recipeId: 0, // 当前食谱id
      proList: [], // 食谱评分数据详情
      showHelp: false, // 评分规则帮助
      currentWeek: '', // 当前天是周几
      helpInfo: [
        {
          id: 1,
          level: 'S',
          des: '≥90(分)'
        },
        {
          id: 2,
          level: 'A',
          des: '80~90(分)'
        },
        {
          id: 3,
          level: 'B',
          des: '70~80(分)'
        },
        {
          id: 4,
          level: 'C',
          des: '60~70(分)'
        },
        {
          id: 5,
          level: 'D',
          des: '≤60(分)'
        }
      ],
      back: false,
      recipeNames: '',
      currentRecipeId: 0, // 当前食谱id
      leaveActive: 0 // 记录离开时的激活标签
    }
  },
  computed: {
    ...mapState(['openId']),
    recipeName() {
      return this.MondayTime + '~' + this.SundayTime
    }
  },
  created() {
    const tenantObj = JSON.parse(localStorage.getItem('teantObj'))
    const leaveTime = JSON.parse(sessionStorage.getItem('leaveTime'))
    if (tenantObj) {
      this.back = true
      this.tenantImg = tenantObj.tenantImg
      this.tenantName = tenantObj.tenantName
      this.tenantId = tenantObj.tenantId
      if (leaveTime) {
        this.leaveActive = leaveTime.leaveActive
        this.MondayTime = leaveTime.MondayTime
        this.SundayTime = leaveTime.SundayTime
        this.getRecipeListByTime()
      } else {
        this.MondayTime = moment(
          new Date(
            new Date().getTime() -
              ((new Date().getDay() || 7) - 1) * 24 * 60 * 60 * 1000
          )
        ).format('YYYY.MM.DD')
        this.SundayTime = moment(
          new Date(
            new Date().getTime() +
              (7 - (new Date().getDay() || 7)) * 24 * 60 * 60 * 1000
          )
        ).format('YYYY.MM.DD')
        this.getRecipeListByTime()
      }
    } else {
      this.$router.push({ path: '/serachFoods' })
    }
    this.getWeeks()
  },
  mounted() {
    this.getBindSchoolList()
  },
  destroyed() {
    console.log(this.active)
    sessionStorage.setItem(
      'leaveTime',
      JSON.stringify({
        leaveActive: this.active,
        MondayTime: this.MondayTime,
        SundayTime: this.SundayTime
      })
    )
  },
  methods: {
    updateWeek(val) {
      this.currentWeek = val
    },
    onChange(value) {
      this.currentRecipeId = value
    },
    // 确认选择时间
    onConfirm(value) {
      const now = new Date(value)
      const currentDay = now.getDay()
      const weeks = new Array('日', '一', '二', '三', '四', '五', '六')
      this.currentWeek = weeks[currentDay]
      const nowTime = now.getTime()
      const day = now.getDay() || 7 //为周日的时候 day 修改为7  否则当天周天会有问题
      const oneDayTime = 24 * 60 * 60 * 1000
      const MondayTime = moment(
        new Date(nowTime - (day - 1) * oneDayTime)
      ).format('YYYY.MM.DD')
      const SundayTime = moment(
        new Date(nowTime + (7 - day) * oneDayTime)
      ).format('YYYY.MM.DD')
      this.MondayTime = MondayTime
      this.SundayTime = SundayTime
      this.tabs = []
      this.recipeListByTime = []
      this.getRecipeListByTime()
      this.arrowTime = false
    },
    // 绑定学校
    handleBindSchool() {
      this.$router.push({ path: '/serachFoods' })
    },
    // 获取当前是周几
    getWeeks() {
      const now = new Date()
      const day = now.getDay()
      const weeks = new Array('日', '一', '二', '三', '四', '五', '六')
      this.currentWeek = weeks[day]
    },
    // 改变学校
    handleChangeSchool(item) {
      this.loading = true
      this.tenantName = item.tenantName
      this.tenantId = item.sysTenantId
      this.tenantImg = item.logoUrl
      localStorage.setItem(
        'teantObj',
        JSON.stringify({
          tenantName: item.tenantName,
          tenantId: item.sysTenantId,
          tenantImg: item.logoUrl
        })
      )
      this.recipeListArr = []
      this.tabs = []
      this.getRecipeListByTime()
      this.schoolPopup = false
      this.loading = false
    },
    // 获取绑定学校列表
    async getBindSchoolList() {
      const res = await bindSchoolList(this.openId)
      if (res.data.code === 200) {
        const result = res.data.data
        if (result.length === 0) {
          this.$router.push({ path: '/serachFoods' })
        } else {
          this.schoolList = result
        }
      }
    },
    // 通过时间获取食谱列表
    async getRecipeListByTime() {
      this.tabs = []
      this.recipeListArr = []
      try {
        const data = {
          startTime: this.MondayTime,
          endTime: this.SundayTime,
          tenantId: this.tenantId
        }
        const res = await recipeListByTime(data)
        if (res.data.code === 200) {
          const result = res.data.data
          if (result && result.length > 0) {
            const result = res.data.data
            result.forEach(ele => {
              this.tabs.push({ name: ele.aliasName, id: ele.id })
            })
            this.recipeListArr = result
            this.active =
              this.leaveActive !== 0 ? this.leaveActive : this.tabs[0].id
            this.currentRecipeId =
              this.leaveActive !== 0 ? this.leaveActive : this.tabs[0].id
            this.loading = false
          } else {
            this.recipeListArr = []
            this.loading = false
            // Notify({ type: 'warning', message: '当前日期学校暂未公开食谱!' })
          }
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style scope lang="less">
.home {
  position: relative;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background: url('../../assets/home/home_bg.png') no-repeat;
  background-size: contain;
  .scroll-container{
    height: calc(100vh - 1rem);
    overflow-y: scroll;
  }
  .date {
    height: 1.3rem;
    box-sizing: border-box;
    .date-name {
      margin: 0 1.5rem;
      color: #5d5d5e;
      background-color: #f5f4f9;
      border-radius: 0.5rem;
      text-align: center;
      line-height: 0.8rem;
      height: 0.8rem;
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 400;
    }
    .my-divider {
      margin: 0;
      margin-top: 0.49rem;
      box-sizing: border-box;
      color: #fafafa;
      opacity: 0.12;
    }
  }
  .container {
    padding: 0 0.2rem;
    position: relative;
    .channel-tabs {
      .van-tabs__wrap {
        margin-bottom: 0.1rem;
        height: 0.9rem;
        .van-tabs__nav {
          padding-left: 0;
          padding-right: 0;
          padding-bottom: 0;
          .van-tab {
            margin-right: 0.2rem;
            flex: unset;
            font-size: 0.33rem;
          }
          .van-tab--active {
            color: #fff;
            font-size: 0.4rem;
          }
        }
        .van-tabs__line {
          height: 0;
        }
      }
    }
    .week-rate {
      position: relative;
      height: 6rem;
      border-radius: 0.2rem;
      box-shadow: 0px 2px 40px 0px rgba(36, 42, 56, 0.12);
      .week-help {
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        width: 0.4rem;
        height: 0.4rem;
      }
      .week-rate-level {
        padding: 0 0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 2.4rem;
        .left {
          display: flex;
          align-items: center;
          img {
            width: 0.4rem;
            height: 0.4rem;
          }
          .week-rate-title {
            margin-left: 0.2rem;
            font-weight: 500;
            letter-spacing: 0.05rem;
            font-size: 0.4rem;
            font-family: PingFangSC, PingFangSC-Medium;
          }
        }
        .right {
          margin-right: 0.35rem;
          img {
            height: 1.7rem;
            width: 1.7rem;
          }
        }
      }
      .week-rate-item {
        padding: 0 0.4rem;
        padding-top: 0.3rem;
        background-color: #fff;
        border-radius: 0.2rem;
        height: 3.4rem;
        .title {
          color: #000;
          font-size: 0.3rem;
          font-weight: normal;
          font-family: PingFangSC, PingFangSC-Medium;
        }
        .circle {
          margin-top: 0.4rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 1.5rem;
          .van-circle {
            width: 100%;
            height: 1.5rem;
          }
          .pr {
            position: relative;
            flex: 1;
            height: 100%;
            .data {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              .rate {
                color: #000;
                font-size: 0.25rem;
                text-align: center;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
              }
              .poor {
                color: #fd6c3b;
              }
              .good {
                color: #31ca8a;
              }
              .normal {
                color: #ffa900;
              }
              .level {
                margin-top: 0.08rem;
                font-size: 0.25rem;
                text-align: center;
              }
            }
            .name {
              position: absolute;
              bottom: -0.7rem;
              left: 50%;
              transform: translate(-50%, 0);
              width: 100%;
              text-align: center;
              color: #000;
              font-weight: 400;
              font-size: 0.26rem;
              font-family: PingFangSC, PingFangSC-Regular;
            }
          }
        }
      }
    }
  }
  // 弹窗样式
  .school-popup {
    padding: 0.4rem;
    height: 100%;
    box-sizing: border-box;
    background-color: #f6f7f8;
    .school-title {
      font-weight: 500;
      font-size: 0.35rem;
      height: 0.8rem;
    }
    .school-list {
      height: calc(100% - 0.8rem);
      overflow: auto;
      .school-item {
        margin: 0.3rem 0;
        padding-left: 0.3rem;
        display: flex;
        align-items: center;
        height: 1.4rem;
        border-radius: 0.2rem;
        background-color: #fff;
        img {
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 50%;
        }
        .name {
          margin-left: 0.4rem;
          font-size: 0.3rem;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 400;
        }
      }
      .school-list::-webkit-scrollbar {
        display: none;
      }
    }
  }
  // 评分规则帮助
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      padding: 0.4rem 0.6rem;
      width: 60%;
      height: 7.2rem;
      border-radius: 0.2rem;
      transform: translate(0, -5%);
      background-color: #fff;
      .block-title {
        margin-bottom: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-left: 0.15rem;
          font-weight: 500;
          font-size: 0.35rem;
        }
      }
      .block-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1rem;
        .block-item-level {
          color: #846ffe;
        }
        .block-item-des {
          color: rgba(0, 0, 0, 0.85);
        }
      }
      .block-button {
        margin-top: 0.3rem;
      }
    }
  }
}
</style>
